import clsx from 'clsx'
import type { ReactNode } from 'react'

const BASE_SHELL = 'flex min-h-[100px] rounded-lg'

const VARIANT_CLASSES = {
  elevated:
    'w-fit shrink-0 bg-white-dark px-6 py-4 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.06),0px_2px_8px_0px_rgba(0,0,0,0.08)]',
  outlined: 'w-full border border-sand bg-white p-4 shadow-sm',
}

interface Props {
  children: ReactNode
  className?: string
  variant?: 'elevated' | 'outlined'
}

export function SummaryCardShell({ children, className, variant = 'elevated' }: Props) {
  return <div className={clsx(BASE_SHELL, VARIANT_CLASSES[variant], className)}>{children}</div>
}
